import { Invoice } from '../../../models/invoice.model';
import { Pagination } from '../../../models/pagination.model';
import { LiveClass, LiveClassResponseDTO } from './models/live-class';

export interface LiveClassState {
  liveClassItems: LiveClass[];
  pagination: Pagination;
  selectedLiveClassItem: LiveClassResponseDTO | null;
  createdLiveClassItem: LiveClass | null;
  isSyncingContents: boolean;
  isSyncSuccess: boolean;
  subscription: {
    invoice: Invoice | null;
    processingPayment: boolean;
    paymentSuccess: boolean;
    error: string | null;
  } | null;
  subscribedLiveClasses: LiveClass[];
  instructorLiveClasses : LiveClass[]
}

export const initialState: LiveClassState = {
  liveClassItems: [],
  pagination: {
    totalDocs: 0,
    limit: 0,
    totalPages: 0,
    page: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: 0,
    nextPage: 0,
  },
  createdLiveClassItem: null,
  selectedLiveClassItem: null,
  isSyncingContents: false,
  isSyncSuccess: false,
  subscription: null,
  subscribedLiveClasses: [],
  instructorLiveClasses: []
};
